"use client"
// Auto-generated by `npx boneyard-js build` — do not edit
import { registerBones } from 'boneyard-js'

import _pdv_venda from './pdv-venda.bones.json'

registerBones({
  "pdv-venda": _pdv_venda,
})
